import vuexApiCall from './vuexApiCall';
export default {
  install: function install(Vue, options) {
    Vue.prototype.vuexApiCall = vuexApiCall;
  }
};